import React from 'react'
import OrderCreateContainer from 'containers/panel/reseller/order-create-container'
const OrderCreatePage = () => {
  return (
    <OrderCreateContainer/>
  )
}

export default OrderCreatePage